export const removeDuplicateFields = (key: string, value: any, additionalFields: any) => {
  let newArray = additionalFields[0].filter((field) => {
    return field.key !== key;
  });

  newArray.push({ key, value });

  return newArray;
};
